module.exports = __webpack_public_path__ + "static/img/10.ff34a6f.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/4/1/eng/10.png
// module id = Kui9
// module chunks = 0